export class ProductStatus {

  color: string;

  name: string;

  serialNumber: string;

  position: number;
}



// WEBPACK FOOTER //
// ./src/models/change-status/productStatus.ts